<div class="dialog-content">
  <app-window-title title="Shared Users"
                    subtitle="Manage file sharing permissions"
                    [closable]="true"
                    (closed)="dialogRef.close()">
  </app-window-title>
  <!-- File Info Section -->
  <div class="file-info-section">
    <div class="file-info-card">
      <div class="file-icon-wrapper">
        <mat-icon class="file-icon">
          description
        </mat-icon>
        <div class="file-type-badge">
          PDF
        </div>
      </div>
      <div class="file-details">
        <p class="file-message">
          The file
          <strong class="file-name-highlight">
            {{data.fileName}}
          </strong>
          is shared with:
        </p>
        <div class="shared-stats">
          <span class="shared-count">
            <mat-icon class="stat-icon">
              people
            </mat-icon>
            {{ data.sharedUsers.length }} {{ data.sharedUsers.length === 1 ? 'user' : 'users' }}
          </span>
          <span *ngIf="data.sharedDate"
                class="shared-date">
            <mat-icon class="stat-icon">
              schedule
            </mat-icon>
            Shared {{ data.sharedDate | date:'shortDate' }}
          </span>
        </div>
      </div>
    </div>
  </div>



  <!-- Loading State -->
  <div *ngIf="loading"
       class="loading-state">
    <div class="loading-content">
      <mat-progress-spinner color="primary"
                   [diameter]="40"></mat-progress-spinner>
      <p class="loading-text">
        Loading user information...
      </p>
      <p class="loading-subtext">
        Please wait while we fetch the latest data
      </p>
    </div>
  </div>

  <!-- Users List -->
  <div *ngIf="!loading && enhancedSharedUsers.length > 0"
       class="users-list">
    <div class="list-header">
      <h3 class="list-title">
        Shared Users
      </h3>
      <div class="list-actions">
        <button class="icon-text-button refresh-button"
                color="primary"
                mat-button
                [disabled]="refreshing"
                (click)="onRefreshData()">
          <mat-icon>
            refresh
          </mat-icon>
          <span>
            Refresh
          </span>
        </button>
        <button class="icon-text-button unshare-all-button"
                color="warn"
                mat-button
                [disabled]="unsharingAll || enhancedSharedUsers.length === 0"
                (click)="onUnshareAll()">
          <mat-icon *ngIf="!unsharingAll">
            link_off
          </mat-icon>
          <mat-progress-spinner *ngIf="unsharingAll"
                       color="warn"
                       [diameter]="16"></mat-progress-spinner>
          <span *ngIf="!unsharingAll">
            Unshare All
          </span>
        </button>
      </div>
    </div>

    <div class="users-grid">
      <div *ngFor="let user of enhancedSharedUsers; trackBy: trackByUser"
           class="user-item"
           [class.user-item-hover]="true">
        <div class="user-avatar">
          <div class="avatar-circle">
            <mat-icon>
              person
            </mat-icon>
          </div>
          <div class="user-status"
               [class.online]="user.isOnline"></div>
        </div>

        <div class="user-info">
          <div class="user-name">
            {{user.name || 'Unknown User'}}
          </div>
          <div class="user-email">
            <mat-icon class="email-icon">
              email
            </mat-icon>
            {{user.email}}
          </div>
          <div *ngIf="user.facilityName"
               class="user-facility">
            <mat-icon class="facility-icon">
              business
            </mat-icon>
            {{user.facilityName}}
          </div>
          <div *ngIf="user.role && user.role !== 'Unknown'"
               class="user-role"
               [ngStyle]="{ '--role-color': getRoleColor(user) }">
            <mat-icon class="role-icon">
              badge
            </mat-icon>
            {{ getRoleDisplayName(user) }}
          </div>
        </div>

        <div class="user-actions">
          <!-- File Count Button -->
          <button class="file-count-button icon-text-button"
                  color="primary"
                  mat-button
                  [disabled]="!user.fileCount || user.fileCount === 0"
                  [matTooltip]="'View ' + user.fileCount + ' shared files'"
                  (click)="onViewSharedFiles(user)">
            <mat-icon>
              folder
            </mat-icon>
            <span>
              {{user.fileCount || 0}} files
            </span>
          </button>

          <!-- Unshare Button -->
          <button class="icon-text-button unshare-button"
                  color="warn"
                  mat-button
                  [disabled]="unsharing"
                  (click)="onUnshareFile(user)">
            <mat-icon *ngIf="!unsharing">
              link_off
            </mat-icon>
            <mat-progress-spinner *ngIf="unsharing"
                         color="warn"
                         [diameter]="16"></mat-progress-spinner>
            <span *ngIf="!unsharing">
              Unshare
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>



  <!-- No Users State -->
  <div *ngIf="!loading && data.sharedUsers.length === 0"
       class="empty-state">
    <div class="empty-content">
      <mat-icon class="empty-icon">
        people_outline
      </mat-icon>
      <h3 class="empty-title">
        No Shared Users
      </h3>
      <p class="empty-description">
        This file is not currently shared with any users.
      </p>
      <button class="empty-action"
              color="primary"
              mat-raised-button
              (click)="onClose()">
        <mat-icon>
          share
        </mat-icon>
        Share File
      </button>
    </div>
  </div>
</div>
